// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3muoy","title":"Images90_title__2jCvu","images":"Images90_images__iHYKm"};